import { useTranslation } from 'react-i18next';
import { ricaricaApp } from '../../utils/ricarica-app';
import { log } from '../../utils/logger';
import './SchermataDiErrore.css';

/**
 * Quello che si vede quando l'app cade.
 *
 * Prima era un `<p>` con una frase inglese cablata, senza bottoni: unico
 * confine d'errore dell'app (`main.tsx`, nessun boundary di rotta e nessun
 * gestore di `vite:preloadError` in tutto `src/`).
 *
 * Il caso che la faceva comparire più spesso non è un bug del codice: è un
 * DEPLOY. `App.tsx` ha undici `lazy()` di produzione dentro un
 * `<Suspense fallback={null}>` senza rete d'errore; un deploy cambia gli hash dei
 * chunk, e una scheda aperta da prima riceve un 404 sul primo `import()`. Da lì
 * l'app intera veniva sostituita da quella frase, e chi la leggeva non aveva
 * NIENTE da premere — nemmeno un ricarico, che è esattamente ciò che serviva.
 *
 * `ricaricaApp()` e non `location.reload()`: se il service worker vecchio controlla
 * ancora la pagina, un ricarico nudo gli richiede le stesse risorse precaricate e
 * rimette in piedi lo stesso bundle rotto. Quella funzione fa passare il comando al
 * worker in attesa prima di ricaricare — ed è documentata proprio su questo punto.
 */
export default function SchermataDiErrore({ error }: { error?: unknown }) {
  const { t } = useTranslation();

  log.error('App', 'schermata di errore mostrata', {
    message: error instanceof Error ? error.message : String(error ?? 'sconosciuto'),
  });

  return (
    <div className="schermata-errore" role="alert">
      <div className="schermata-errore-card">
        <h1 className="schermata-errore-titolo">{t('common.error')}</h1>
        <p className="schermata-errore-testo">{t('common.errorBoundary')}</p>
        <button
          type="button"
          className="schermata-errore-btn"
          onClick={() => { void ricaricaApp(); }}
        >
          {t('common.retry')}
        </button>
      </div>
    </div>
  );
}
